import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-black mb-8 text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg mb-6">
              <strong>Last Updated:</strong> January 1, 2025
            </p>

            <p className="mb-6">
              Lincoln Asphalt & Concrete ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Information We Collect</h2>
            
            <h3 className="text-2xl font-bold mt-8 mb-3 text-gray-900">Personal Information</h3>
            <p className="mb-4">We may collect personal information that you voluntarily provide to us when you:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Request a quote or estimate</li>
              <li>Contact us via phone, email, or contact form</li>
              <li>Subscribe to our newsletter</li>
              <li>Schedule a service appointment</li>
            </ul>
            <p className="mb-6">This information may include: name, email address, phone number, mailing address, and project details.</p>

            <h3 className="text-2xl font-bold mt-8 mb-3 text-gray-900">Automatically Collected Information</h3>
            <p className="mb-6">
              When you visit our website, we may automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies installed on your device. We may also collect information about your browsing behavior, such as pages viewed and links clicked.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Provide, operate, and maintain our services</li>
              <li>Process your requests and respond to inquiries</li>
              <li>Send you quotes, estimates, and service information</li>
              <li>Communicate with you about appointments and projects</li>
              <li>Send marketing and promotional communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Information Sharing and Disclosure</h2>
            <p className="mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (e.g., email service providers, analytics providers)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, sale, or acquisition of our business</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Cookies and Tracking Technologies</h2>
            <p className="mb-6">
              We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Data Security</h2>
            <p className="mb-6">
              We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Your Privacy Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
              <li>Object to processing of your personal information</li>
            </ul>
            <p className="mb-6">
              To exercise these rights, please contact us at info@lincolnasphalt.com or (402) 555-0123.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Third-Party Links</h2>
            <p className="mb-6">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Children's Privacy</h2>
            <p className="mb-6">
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Changes to This Privacy Policy</h2>
            <p className="mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4 text-gray-900">Contact Us</h2>
            <p className="mb-4">If you have questions about this Privacy Policy, please contact us:</p>
            <div className="bg-gray-50 rounded-xl p-6 mb-6">
              <p className="mb-2"><strong>Lincoln Asphalt & Concrete</strong></p>
              <p className="mb-2">123 Paving Street</p>
              <p className="mb-2">Lincoln, NE 68501</p>
              <p className="mb-2">Phone: (402) 555-0123</p>
              <p>Email: info@lincolnasphalt.com</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}